import YachtsService from '@/services/api/Yachts'
import ContractorsService from '@/services/api/Contractors'
import StaffService from '@/services/api/Staff'
import InventoryItemsIssuedService from '@/services/api/InventoryItemsIssued'
import Yacht from '@/models/Yacht'
import ability from '@/plugins/ability'
import ServiceTask from '@/models/ServiceTask'

// initial state
const state = {
  yachts: {
    data: [],
    loading: false
  },
  staff: {
    data: [],
    loading: false
  },
  contractors: {
    data: [],
    loading: false
  },
  currentLocation: {
    base: null,
    country: null
  },
  inventoryItemsIssued: {
    data: [],
    loading: false
  },
  allAssignables: []
}

// getters
const getters = {
  allAssignables: function (state) {
    let all = []

    for (let s of state.staff.data) {
      all.push({ ...s, type: ServiceTask.ASSIGNEE_TYPE_STAFF })
    }

    for (let c of state.contractors.data) {
      all.push({ ...c, type: ServiceTask.ASSIGNEE_TYPE_CONTRACTOR })
    }

    return all
  },
  contractors: function (state) {
    return state.contractors
  },
  inventoryItemsIssued: function (state) {
    return state.inventoryItemsIssued
  },
  staff: function (state) {
    return state.staff
  },
  yachts: function (state) {
    return state.yachts
  }
}

// actions
const actions = {
  getBasicData: function ({ dispatch }) {
    dispatch('initCurrentLocation')
    dispatch('fetchInventoryItemsIssued')
  },
  fetchYachts: async function({ commit, state }) {
    if (!ability.can('view', 'Yacht')) return

    commit('YACHTS_LOADING', true)

    const query = {
      status: [Yacht.STATUS_IN_USE, Yacht.STATUS_DELIVERY, Yacht.STATUS_PHASED_OUT],
      ...state.currentLocation.base && { current_base_id: state.currentLocation.base.id },
      ...(!state.currentLocation.base && state.currentLocation.country) && { country_id: state.currentLocation.country.id }
    }

    let yachts = await YachtsService.fetchYachts(query)

    commit('YACHTS_LOADING', false)
    commit('SET_YACHTS', {
      data: yachts
    })
  },
  fetchStaff: async function ({ commit, state }) {
    if (!ability.can('view', 'Staff')) return

    commit('STAFF_LOADING', true)

    const query = {
      ...state.currentLocation.base && { current_base_id: state.currentLocation.base.id },
      ...(!state.currentLocation.base && state.currentLocation.country) && { current_country_id: state.currentLocation.country.id }
    }

    let staff = await StaffService.fetch(query)

    commit('STAFF_LOADING', false)
    commit('SET_STAFF', {
      data: staff
    })
  },
  fetchContractors: async function ({ commit }) {
    if (!ability.can('view', 'Contractor')) return

    commit('CONTRACTORS_LOADING', true)

    const query = {
      ...state.currentLocation.country && { country_id: state.currentLocation.country.id }
    }

    let contractors = await ContractorsService.fetch(query)

    commit('CONTRACTORS_LOADING', false)
    commit('SET_CONTRACTORS', {
      data: contractors
    })
  },
  fetchInventoryItemsIssued: async function ({ commit }) {
    commit('INVENTORY_ITEMS_ISSUED_LOADING', true)

    let inventoryItemsIssued = await InventoryItemsIssuedService.fetchForMe()

    commit('SET_INVENTORY_ITEMS_ISSUED', {
      data: inventoryItemsIssued
    })
    commit('INVENTORY_ITEMS_ISSUED_LOADING', false)
  },
  initCurrentLocation: function ({ commit, dispatch, rootState }) {
    if (ability.can('service-allow-all-countries', null)) {
      // dispatch('fetchYachts')
      dispatch('fetchStaff')
      dispatch('fetchContractors')
      return
    }

    const country = rootState.auth.user.service_allow_countries[0]

    dispatch('setCurrentCountry', country)
  },
  setCurrentCountry: function ({ commit, rootState, dispatch }, country) {
    commit('SET_CURRENT_COUNTRY', country)

    dispatch('fetchContractors')

    if (ability.can('service-allow-all-bases', null)) {
      dispatch('setCurrentBase', null)
      return
    }

    const base = rootState.auth.user.service_allow_bases.find(b => b.country_id === country.id)

    dispatch('setCurrentBase', base)
  },
  setCurrentBase: function ({ commit, dispatch }, base) {
    commit('SET_CURRENT_BASE', base)

    dispatch('fetchYachts')
    dispatch('fetchStaff')
  }
}

// mutations
const mutations = {
  YACHTS_LOADING: function (state, value) {
    state.yachts.loading = value
  },
  SET_YACHTS: function (state, { data }) {
    state.yachts.data = data
  },
  STAFF_LOADING: function (state, value) {
    state.staff.loading = value
  },
  SET_STAFF: function (state, { data }) {
    state.staff.data = data
  },
  CONTRACTORS_LOADING: function (state, value) {
    state.contractors.loading = value
  },
  SET_CONTRACTORS: function (state, { data }) {
    state.contractors.data = data
  },
  SET_CURRENT_BASE: function (state, base) {
    state.currentLocation.base = base
  },
  SET_CURRENT_COUNTRY: function (state, country) {
    state.currentLocation.country = country
  },
  INVENTORY_ITEMS_ISSUED_LOADING: function (state, val) {
    state.inventoryItemsIssued.loading = val
  },
  SET_INVENTORY_ITEMS_ISSUED: function (state, { data }) {
    state.inventoryItemsIssued.data = data
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
